import React, { useEffect, useRef, useState } from 'react';



export function PRCDropDown(props) {

    let initialised = useRef(false);

    const [selectedValue, setSelectedValue] = useState();


    if (props.reset === true) {
        initialised.current = false;
    }
    function handleOnClick(method) {
        if (method) {
            method();
        }
    }
    function handleInputChange(e) {
        setSelectedValue(e.target.value);
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    }
    useEffect(() => {

        if (props.value >= 0) {
            setSelectedValue(props.value);
            initialised.current = true;
        }

    }, [setSelectedValue, initialised, props.value]);

    return (
        <>
            <select className={props.className} onClick={handleOnClick(props.onClick)} value={selectedValue} name={props.name} id={props.id} onChange={(e) => handleInputChange(e)}>
                {props.options.map((option) => (
                    <option key={option.id || 0} value={option.id}>{option.description}</option>
                ))}

            </select>
        </>

    );
}